// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "010a80dc5d572bd05bbabb836107c0eeb5754f4e/static/css/" + chunkId + "." + {"200":"4f7b3521","825":"f81e5cfb","864":"f2764e67"}[chunkId] + ".chunk.css";
};